import { render } from "./IncommingNotify.vue?vue&type=template&id=62dc7cd2"
import script from "./IncommingNotify.vue?vue&type=script&lang=js"
export * from "./IncommingNotify.vue?vue&type=script&lang=js"

import "./IncommingNotify.vue?vue&type=style&index=0&id=62dc7cd2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__